module.exports = __webpack_public_path__ + "static/default-bg-d7fac3c9ba6c6f8a44b443bc357ae53e.jpg";